import { ReactNode } from 'react'
import { themeColors } from '../../app/layout/theme'
import {
  Button, Typography, CircularProgress, Box,
} from '@mui/material'
import { EntityModal } from './EntityModal'
import { Delete as DeleteIcon } from '@mui/icons-material'

interface DeleteDialogProps {
  open: boolean
  /** Display name of the item being deleted */
  name?: string | null
  /** Dialog title, e.g. "Delete User", "Delete Role" */
  title?: string
  /** Completely custom body message (replaces the default text) */
  description?: string
  onClose: () => void
  onConfirm: () => void
  isDeleting: boolean
  /** Extra content rendered below the message (e.g. warning alerts) */
  children?: ReactNode
  /** Disable the confirm button for reasons other than loading */
  confirmDisabled?: boolean
}

export const DeleteDialog = ({
  open,
  name,
  title = 'Delete',
  description,
  onClose,
  onConfirm,
  isDeleting,
  children,
  confirmDisabled,
}: DeleteDialogProps) => {
  return (
    <EntityModal
      open={open}
      onClose={onClose}
      onSubmit={onConfirm}
      title={title}
      submitLabel="Delete"
      isSubmitting={isDeleting}
      submitDisabled={confirmDisabled}
      maxWidth="xs"
      icon={<DeleteIcon sx={{ fontSize: 18 }} />}
      submitProps={{ color: 'error' }}
    >
      <Box>
        <Typography sx={{ fontSize: '14px', color: themeColors.text.secondary }}>
          {description ?? (
            <>Are you sure you want to delete{name ? <> <strong>{name}</strong></> : ' this item'}? This action cannot be undone.</>
          )}
        </Typography>
        {children}
      </Box>
    </EntityModal>
  )
}
